import { i18nService } from './I18nService';
const I18N_PREFIX = 'i18n:';
export function resolveText(text, params) {
    if (!text.startsWith(I18N_PREFIX))
        return text;
    return i18nService.t(text.slice(I18N_PREFIX.length), params);
}
